import { combineReducers } from 'redux';

import { FETCH_DEFAULT_CHECKLIST_REQUEST } from 'modules/checklists/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import id from './id';

const defaultSlice = combineReducers({
  id,
  isFetching: loading(FETCH_DEFAULT_CHECKLIST_REQUEST),
});

export type ChecklistUiDefaultReducer = ReturnType<typeof defaultSlice>;

export default defaultSlice;
